import { searchApiKeysMap } from '.';

export default (query?: Record<string, string>): Record<string, string> => {
  if (!query) {
    return {};
  }
  const clone = { ...query };
  Object.keys(searchApiKeysMap).forEach((key) => delete clone[key]);
  return clone;
};
